import axios from "axios";
import { baseUrl } from "../constant/constant";
import ApiInterceptor from "../interceptors/api_interceptor";

// Single shared axios instance used by every service in stores/services/*.
// ApiInterceptor attaches the request-side `Authorization` header (read from
// the `_aps_t` cookie) and the response-side 401 → auto-logout flow.
// Without this wrap nothing in the app ever sends a bearer token, so every
// auth-protected endpoint (follow, my-tickets, payout-bank, etc.) 401s even
// when the user is signed in.
export const request = ApiInterceptor(axios.create({
    baseURL: baseUrl,
    timeout: 100000,
    headers: {
        "Accept": "application/json",
    },
}));
